import React, { useContext } from "react";
import { DealerDataContext } from "../../context/DealerDataContext";

const ContactWays = ({ contact }) => {
  const { dealerData } = useContext(DealerDataContext);

  return (
    <div className="w-full grid grid-cols-6">
      <span className="col-span-4 col-start-2">
        {!contact && <h2 className="title text-center">راه های ارتباطی</h2>}

        <div className="grid grid-cols-4 gap-4 w-full mt-4">
          <a
            target="_blank"
            rel="noreferrer"
            href={`tel:${dealerData?.phone}`}
            className="box-contact"
          >
            <img src="/Call.png" alt="Call" className="w-[25px]" />
            {dealerData?.phone}
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={dealerData?.whatsapp}
            className="box-contact"
          >
            <img src="/whatsapp.png" alt="Call" className="w-[25px]" />
            1924whatsapp
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={dealerData?.instagram}
            className="box-contact"
          >
            <img src="/mdi_instagram.png" alt="Call" className="w-[25px]" />
            1924instagram
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={dealerData?.aparat}
            className="box-contact"
          >
            <img src="/aparat.svg" alt="Aparat" className="w-[25px]" />
            1924aparat
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={`mailto:${dealerData?.email}`}
            className="box-contact col-span-2"
          >
            <img src="/Message.png" alt="Call" className="w-[25px]" />
            {dealerData?.email}
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={dealerData?.telegram}
            className="box-contact col-span-2"
          >
            <img src="/la_telegram.png" alt="Call" className="w-[25px]" />
            1924-Support
          </a>
        </div>
      </span>
    </div>
  );
};

export default ContactWays;
